import { Card, Col, Divider, Form, Input, Row } from 'antd';
import dayjs from 'dayjs';

export default function RepresentativesSection({ authorizedPeople, qt }) {
  return (
    <Card
      title={
        <div
          style={{
            whiteSpace: 'normal',
            wordWrap: 'break-word',
            lineHeight: '1.5',
          }}
        >
          {qt('questionnaire.representativesInfo')}
        </div>
      }
      className="mb-5"
      style={{ marginBottom: '20px' }}
    >
      {authorizedPeople && authorizedPeople.length > 0 ? (
        authorizedPeople.map((person, index) => (
          <div key={index}>
            {index > 0 && <Divider />}
            <h4 style={{ marginBottom: '15px' }}>
              {qt('questionnaire.representative')} {index + 1}
            </h4>

            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  label={qt('questionnaire.firstLastName')}
                  style={{ marginBottom: '10px' }}
                >
                  <Input value={person.name} disabled />
                </Form.Item>
              </Col>

              <Col span={12}>
                <Form.Item
                  label={qt('questionnaire.personalNumber')}
                  style={{ marginBottom: '10px' }}
                >
                  <Input
                    value={person.personalNumber || person.JMBG || ''}
                    disabled
                  />
                </Form.Item>
              </Col>

              <Col span={12}>
                <Form.Item
                  label={qt('questionnaire.dateOfBirth')}
                  style={{ marginBottom: '10px' }}
                >
                  <Input
                    value={
                      person.dateOfBirth
                        ? dayjs(person.dateOfBirth).format('DD-MM-YYYY')
                        : ''
                    }
                    disabled
                  />
                </Form.Item>
              </Col>

              <Col span={12}>
                <Form.Item
                  label={qt('questionnaire.placeOfBirth')}
                  style={{ marginBottom: '10px' }}
                >
                  <Input
                    value={
                      person.placeOfBirth && person.countryOfBirth
                        ? `${person.placeOfBirth}, ${person.countryOfBirth}`
                        : person.placeOfBirth || person.countryOfBirth || ''
                    }
                    disabled
                  />
                </Form.Item>
              </Col>

              <Col span={12}>
                <Form.Item
                  label={qt('questionnaire.streetNumberResidence')}
                  style={{ marginBottom: '10px' }}
                >
                  <Input value={person.addressOfResidence} disabled />
                </Form.Item>
              </Col>

              <Col span={12}>
                <Form.Item
                  label={qt('questionnaire.placeCountryResidence')}
                  style={{ marginBottom: '10px' }}
                >
                  <Input
                    value={
                      person.placeOfResidence && person.countryOfResidence
                        ? `${person.placeOfResidence}, ${person.countryOfResidence}`
                        : person.placeOfResidence ||
                          person.countryOfResidence ||
                          ''
                    }
                    disabled
                  />
                </Form.Item>
              </Col>

              <Col span={12}>
                <Form.Item
                  label={qt('questionnaire.typeNumberPersonalId')}
                  style={{ marginBottom: '10px' }}
                >
                  <Input
                    value={
                      person.typeNumberAndIssuerOfDocument ||
                      `${person.typeOfDocument || '-'}, ${person.numberOfDocument || '-'}`
                    }
                    disabled
                  />
                </Form.Item>
              </Col>

              <Col span={12}>
                <Form.Item
                  label={qt('questionnaire.datePlaceIssueId')}
                  style={{ marginBottom: '10px' }}
                >
                  <Input
                    value={
                      person.placeAndDateOfIdDocIssue ||
                      `${person.placeOfIdDocIssue || '-'}, ${
                        person.dateOfIdDocIssue
                          ? dayjs(person.dateOfIdDocIssue).format('DD-MM-YYYY')
                          : '-'
                      }`
                    }
                    disabled
                  />
                </Form.Item>
              </Col>

              <Col span={12}>
                <Form.Item
                  label={qt('questionnaire.issuerId')}
                  style={{ marginBottom: '10px' }}
                >
                  <Input
                    value={person.issuerOfDocument || person.issuerId || 'N/A'}
                    disabled
                  />
                </Form.Item>
              </Col>
            </Row>
          </div>
        ))
      ) : (
        <p>{qt('questionnaire.noAuthorizedRepresentativesFound')}</p>
      )}

      <Divider />

      <Form.Item
        label={qt('questionnaire.reasonForAbsenceRepresentative')}
        name="reasonOfAbsenceOfRepresentative"
        style={{ marginBottom: '10px' }}
      >
        <Input.TextArea
          rows={3}
          placeholder={qt('questionnaire.enterReasonForAbsence')}
        />
      </Form.Item>
    </Card>
  );
}
